import onlineReputationData from './online-reputation-content.json';
import type { OnlineReputationContent } from './types';

export * from './types';

export const onlineReputationContent = onlineReputationData as OnlineReputationContent;
